import React from 'react';
import { Zap, Upload, AlertTriangle } from 'lucide-react';

const VerificationMethodBadge = ({ verificationMethod, integrationSource }) => {
  // Source display names
  const sourceNames = {
    aws: 'AWS',
    google_workspace: 'Google Workspace',
    github: 'GitHub',
  };

  if (verificationMethod === 'automated_integration') {
    const sourceName = sourceNames[integrationSource] || integrationSource;
    return (
      <div className="flex items-center gap-1.5 px-2 py-1 bg-green-50 border border-green-200 rounded text-xs">
        <Zap className="w-3.5 h-3.5 text-green-600" />
        <span className="font-medium text-green-700">
          Auto-verified via {sourceName}
        </span>
      </div>
    );
  }

  if (verificationMethod === 'manual_with_upload') {
    return (
      <div className="flex items-center gap-1.5 px-2 py-1 bg-blue-50 border border-blue-200 rounded text-xs">
        <Upload className="w-3.5 h-3.5 text-blue-600" />
        <span className="font-medium text-blue-700">Manual — upload required</span>
      </div>
    );
  }

  if (verificationMethod === 'manual_self_report') {
    return (
      <div className="flex items-center gap-1.5 px-2 py-1 bg-amber-50 border border-amber-200 rounded text-xs">
        <AlertTriangle className="w-3.5 h-3.5 text-amber-600" />
        <span className="font-medium text-amber-700">Self-reported</span>
      </div>
    );
  }

  // Default: no badge if verification method is not recognized
  return null;
};

export default VerificationMethodBadge;
